import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

class App extends Component {
  componentDidMount() {
    if (typeof window.startx === "function") {
      window.startx();
    }
  }

  render() {
    return (
      <>
        <Helmet>
          <title>Museo El Rehilete | Ciencia, Tecnología y Diversión en Hidalgo</title>

          <meta
            name="description"
            content="Museo interactivo El Rehilete en Hidalgo. Descubre ciencia, tecnología, realidad virtual, planetario y actividades educativas para toda la familia."
          />

          <meta
            name="keywords"
            content="Museo El Rehilete, museo interactivo Hidalgo, planetario Pachuca, realidad virtual museo, actividades para niños Pachuca"
          />

          <meta name="author" content="Museo El Rehilete" />
        </Helmet>

        <div id="page-wrapper">

          {/* HERO / CAROUSEL */}
          <section id="zero">
            <div
              id="carouselExampleControls"
              className="carousel slide"
              data-ride="carousel"
              data-interval="2500"
            >
              <div className="carousel-inner">
                {["d1","d2","d3","d4","d5","d6"].map((img, i) => (
                  <div key={img} className={`carousel-item ${i === 0 ? "active" : ""}`}>
                    <img
                      className="d-block w-100 mt-4"
                      src={`/images/${img}.jpg`}
                      alt="Museo interactivo El Rehilete Pachuca Hidalgo"
                    />
                  </div>
                ))}
              </div>

              <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                <span className="carousel-control-prev-icon" />
              </a>

              <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                <span className="carousel-control-next-icon" />
              </a>
            </div>

            <a href="#one" className="goto-next scrolly">Siguiente</a>
          </section>

          {/* BIENVENIDA */}
          <section id="one" className="spotlight style1 bottom">
            <span className="image fit main avion">
              <img src="/images/imagenRehilete.jpg" alt="Museo El Rehilete Hidalgo México" />
            </span>

            <div className="content">
              <div className="container">
                <header>
                  <h3>Bienvenidos</h3>
                  <h5 className="TextBienJustify">
                    Quienes colaboramos aquí deseamos hacer de tu visita, una experiencia única de aprendizaje y diversión.
                    Tenemos para ti diversas propuestas y retos que harán tu visita divertida e interesante.
                    <br /><br />
                    Explora más de 100 opciones: módulos interactivos, talleres, dinámicas y exposiciones.
                    Contamos con estacionamiento y servicio médico.
                    <br /><br />
                    ¡Te esperamos!
                  </h5>
                </header>
              </div>
            </div>

            <a href="#three" className="goto-next scrolly">Next</a>
          </section>

          {/* SALA VR */}
          <section id="three" className="spotlight style2 left">
            <span className="image fit main bottom">
              <img src="/images/vr/bannerrv.png" alt="Sala de realidad virtual Museo El Rehilete" />
            </span>

            <div className="content">
              <header>
                <h2 className="inicio">Nueva Sala de Realidad Virtual</h2>
              </header>

              <ul className="actions">
                <li>
                  <Link to="/nuevasalarv" className="button">
                    Ver Sala
                  </Link>
                </li>
              </ul>
            </div>

            <a href="#four" className="goto-next scrolly">Next</a>
          </section>

          {/* ÁREAS */}
          <section id="four" className="spotlight style2 right">
            <span className="image fit main bottom">
              <img src="/images/areas_web.jpg" alt="Áreas y servicios del Museo El Rehilete" />
            </span>

            <div className="content">
              <header>
                <h2 className="inicio">Áreas y Servicios</h2>
                <p>Explora nuestras áreas temáticas de ciencia, arte y tecnología</p>
              </header>

              <ul className="actions">
                <li>
                  <Link to="/areasyservicios" className="button">
                    Ver Áreas y Servicios
                  </Link>
                </li>
              </ul>

              <ul className="actions">
                <li>
                  <a
                    href="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/MINJHRehilete/dir3/Web/Cartelera_Planetario.jpg"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="button"
                  >
                    Cartelera Planetario
                  </a>
                </li>
              </ul>
            </div>

            <a href="#five" className="goto-next scrolly">Next</a>
          </section>

          {/* MINIJUEGOS */}
          <section id="five" className="spotlight style2 left">
            <span className="image fit main bottom">
              <img src="/images/minijuegos.jpg" alt="Minijuegos educativos Museo El Rehilete" />
            </span>

            <div className="content">
              <ul className="actions">
                <li>
                  <Link to="/juego" className="button">
                    Entrar
                  </Link>
                </li>
              </ul>
            </div>

            <a href="#six" className="goto-next scrolly">Next</a>
          </section>

          {/* BLOG */}
          <section id="six" className="spotlight style2 right">
            <span className="image fit main bottom">
              <img src="/images/Blog/BlogPortada.png" alt="Blog educativo Museo El Rehilete" />
            </span>

            <div className="content">
              <ul className="actions">
                <li>
                  <Link to="/blog" className="button">
                    Blog
                  </Link>
                </li>
              </ul>
            </div>
          </section>

        </div>
      </>
    );
  }
}

export default App;